module.exports = __webpack_public_path__ + "static/media/leiza-grimberg.0ae7a471.jpg";